import React from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import styled from "../style.module.css";
import { ACCENTS, TOOLTIP_STYLE } from "./theme";

// Reusable donut. `data` rows mapped to { name, value } via nameKey/valueKey.
// Each row's color is fixed by its position in `rows` (or an explicit
// `row.color`) BEFORE empty rows are dropped -- coloring after the filter
// shifted colors whenever an earlier row was 0 (e.g. "Returning" turned
// copper when "New" was 0). `keepZero` keeps 0-value rows in the legend so a
// fixed category set (New/Returning) always shows every category + its color.
const BreakdownDonut = ({ title, rows, nameKey, valueKey, formatValue, emptyHint, asOf = true, keepZero = false, subtitle = null }) => {
  const data = (rows || [])
    .map((r, i) => ({ name: r[nameKey], value: Number(r[valueKey]) || 0, color: r.color || ACCENTS[i % ACCENTS.length] }))
    .filter((d) => keepZero || d.value > 0);
  const total = data.reduce((s, d) => s + d.value, 0);

  return (
    <div className={styled.chartCard}>
      <div className={styled.chartCardHead}>
        <h3 className={styled.chartTitle}>{title}</h3>
        {asOf && <span className={styled.asOfTag}>Live</span>}
      </div>
      {subtitle && <p className={styled.listNote}>{subtitle}</p>}
      {total > 0 ? (
        <div className={styled.donutWrap}>
          <ResponsiveContainer width="100%" height={220} minWidth={0}>
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                innerRadius={55}
                outerRadius={85}
                paddingAngle={2}
                stroke="none"
              >
                {data.map((d, i) => (
                  <Cell key={i} fill={d.color} />
                ))}
              </Pie>
              <Tooltip
                {...TOOLTIP_STYLE}
                formatter={(v, n) => [formatValue ? formatValue(v) : v, n]}
              />
              <Legend wrapperStyle={{ fontSize: 12, color: "rgba(255,255,255,0.7)" }} />
            </PieChart>
          </ResponsiveContainer>
          <div className={styled.donutCenter}>
            <span className={styled.donutTotalLabel}>Total</span>
            <span className={styled.donutTotalValue}>{formatValue ? formatValue(total) : total.toLocaleString()}</span>
          </div>
        </div>
      ) : (
        <p className={styled.emptyHint}>{emptyHint || "No data yet."}</p>
      )}
    </div>
  );
};

export default BreakdownDonut;
